export default "__VITE_ASSET__85a53876__"